module.exports = __webpack_public_path__ + "static/media/iphone_sim.4641acc3.svg";